export const groupsConfig = {
  groupColors: [
    {
      name: 'Sand',
      background: '#F5E6D3',
      text: '#8B7355',
    },
    {
      name: 'Cream',
      background: '#FFF8E7',
      text: '#9C8B6E',
    },
    {
      name: 'Sky',
      background: '#E3F2FD',
      text: '#5B7FA3',
    },
    {
      name: 'Powder',
      background: '#E8EAF6',
      text: '#5C6090',
    },
    {
      name: 'Seafoam',
      background: '#E0F2F1',
      text: '#4A7C76',
    },
    {
      name: 'Lavender',
      background: '#F3E5F5',
      text: '#7D6283',
    },
    {
      name: 'Blush',
      background: '#FCE4EC',
      text: '#946B7A',
    },
    {
      name: 'Sage',
      background: '#E8F5E9',
      text: '#5A7A5C',
    },
  ],
};

export const groupColors = groupsConfig.groupColors;

const fallbackColor = {
  background: '#F3F4F6',
  text: '#374151',
};

export const getGroupColorByName = (name) => {
  return (
    groupColors.find((groupColor) => groupColor.name === name) || fallbackColor
  );
};
